import React from 'react';
import { styled } from '@mui/material/styles';
import { cloneDeep } from 'lodash';
import { withFormsy } from 'formsy-react';
import Chip from '@mui/material/Chip';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Input from '@mui/material/Input';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const PREFIX = 'TextListFormsy';

const classes = {
  root: `${PREFIX}-root`,
  chip: `${PREFIX}-chip`,
  input: `${PREFIX}-input`,
  label: `${PREFIX}-label`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {
    minHeight: 55,
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },

  [`& .${classes.chip}`]: {
    margin: theme.spacing(0.5),
  },

  [`& .${classes.input}`]: {
    width: '100%',
  },

  [`& .${classes.label}`]: {
    marginBottom: 5,
  },
}));

// TODO: write into a class component or split the modal into a new component.
function TextListInput(props) {
  const { label, name, disabled } = props;
  const value = Array.isArray(props.value) ? props.value : [];
  const { t } = useTranslation('default');
  const [chipData, setChipData] = React.useState(value);
  const [newItem, setNewItem] = React.useState({
    open: false,
    item: '',
  });

  const handleDelete = (chipToDelete) => () => {
    const remainingChips = chipData.filter((chip) => chip !== chipToDelete);
    setChipData(remainingChips);
  };

  const handleOpen = () => {
    setNewItem({
      open: true,
      item: '',
    });
  };

  const handleAdd = (e) => {
    e.stopPropagation();
    const ni = newItem.item;
    if (ni && !chipData.includes(ni)) {
      const newChipData = cloneDeep(chipData);
      newChipData.push(ni);
      setChipData(newChipData);
      const { setValue } = props;
      setValue && setValue(newChipData);
    }
    setNewItem({
      open: false,
      item: '',
    });
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setNewItem({
      open: false,
      item: '',
    });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdd(e);
    }
  };

  const renderDialog = (title) => {
    return (
      <Dialog
        open={newItem.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onKeyPress={handleKeyPress}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Input
              className={classes.input}
              onChange={(e) => setNewItem({ open: true, item: e.target.value })}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('cancel')}
          </Button>
          <Button onClick={handleAdd} color="primary" autoFocus>
            {t('add')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <Root>
      <InputLabel className={classes.label} htmlFor={name}>
        {label}
      </InputLabel>
      <Paper
        id={name}
        variant="outlined"
        onClick={disabled ? null : handleOpen}
        label="test"
        component="ul"
        className={classes.root}
      >
        {chipData.map((data) => {
          return (
            <li key={data}>
              <Chip label={data} onDelete={handleDelete(data)} className={classes.chip} />
            </li>
          );
        })}
        {renderDialog(label)}
      </Paper>
      <FormHelperText id="my-helper-text">
        {disabled ? 'Field is disabled for adding new items' : 'Click to add a list of options'}
      </FormHelperText>
    </Root>
  );
}

TextListInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  setValue: PropTypes.func,
};

export default React.memo(withFormsy(TextListInput));
